import { useEffect, useState } from "react";
import { Button, Typography, Box, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import addgallery from '../../../src/assests/images/gallaryIcon.svg'
import plus from '../../../src/assests/images/plusRed.svg'
import { uploadimage } from "./api";
import { getToken } from "../../utils/utils";
import { useParams } from "react-router-dom";

interface ImageUploadProps {
  images: { url: string; source: string }[];
  setImages: React.Dispatch<React.SetStateAction<{ url: string; source: string }[]>>;
  uploadimagesapicall: (file: File) => Promise<string | null>;
  large_banner_image: string;
  additionalimages_banner_image: string;
}


const ImageUploadComponent:React.FC <ImageUploadProps> = ({images, setImages,uploadimagesapicall,large_banner_image,additionalimages_banner_image }) => {
  
  const { bannerId } = useParams();
  const BASE_URL = process.env.REACT_APP_API_URL + "/uploads/";

  // Set default images if bannerId exists
  useEffect(() => {
    if (bannerId) {
      const defaultImages = [];
  
      if (large_banner_image) {
        defaultImages.push({ url: BASE_URL + large_banner_image, source: "first" });
      }
  
      if (additionalimages_banner_image) {
        const additionalImages = additionalimages_banner_image
          .split(",")
          .map((img) => ({ url: BASE_URL + img.trim(), source: "additional" }));
        defaultImages.push(...additionalImages);
      }
  
      setImages(defaultImages);
    }
  }, [bannerId, large_banner_image, additionalimages_banner_image, setImages]);
  

  const handleFirstButtonUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        const uploadedFileName = await uploadimagesapicall(file);
        if (uploadedFileName) {
          setImages((prevImages) => {
            if (prevImages.length > 0) {
              return [{ url: BASE_URL + uploadedFileName, source: "first" }, ...prevImages.slice(1)];
            }
            return [{ url: BASE_URL + uploadedFileName, source: "first" }];
          });
        }
      }
    }
  };
  

  const handleAddMoreUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0 && images.length < 5) {
      const file = event.target.files[0];
      if (file) {
        const uploadedFileName = await uploadimagesapicall(file);
        if (uploadedFileName) {
          setImages((prevImages) => [...prevImages, { url: BASE_URL + uploadedFileName, source: "additional" }].slice(0, 5));
        }
      }
    } else {
      alert("Maximum 5 images allowed!");
    }
  };
  

  const handleDeleteImage = (index: number) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };
console.log(images, "imagesdddddddddddd")
  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      {/* Upload Image Button (Replaces Image) */}
      <Button
        component="label"
        sx={{
          borderRadius: "12px",
          border: "1px dashed #C5C6C7",
          background: "#FFF",
          padding: "0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "47%",
          textAlign:"center",
          height: 200,
          position: "relative",
          overflow: "hidden",
        }}
       >
        {images.length > 0 ? (
          <Box position="relative" width="100%" height="100%">
            <img
            crossOrigin="anonymous" 
            src={images[0].url}
            alt="Uploaded"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <IconButton
              onClick={() => handleDeleteImage(0)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                background: "rgba(0,0,0,0.5)",
                color: "white",
                '&:hover': { background: "rgba(0,0,0,0.7)" }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        ) : (
          <>
            <img crossOrigin="anonymous" src={addgallery} alt="gallery" width={54} height={54}/>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#696A6B",
                margin: "8px 0 10px",
                textTransform:"capitalize"
              }}
            >
              Drag & Drop your Image/Gif here or Choose file
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "#7D7E7F" }}>
              PNG, JPG, GIF, SVG (Max 5 MB)
            </Typography>
          </>
        )}
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={handleFirstButtonUpload}
        />
      </Button>

      <Box display="flex" gap={2} flexWrap="wrap">
        {images.slice(1).map((src, index) => (
          <Box
            key={index}
            sx={{
              width: 552,
              height: 200,
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #C5C6C7",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative"
            }}
          >
            <img
            crossOrigin="anonymous"
            src={src.url}              
              alt={`Uploaded ${index}`}
              width="100%"
              height="100%"
              style={{ objectFit: "cover" }}
            />
            <IconButton
              onClick={() => handleDeleteImage(index + 1)}
              sx={{
                position: "absolute",
                top: 4,
                right: 4,
                background: "rgba(0,0,0,0.5)",
                color: "white",
                '&:hover': { background: "rgba(0,0,0,0.7)" }
              }}
             >
              <CloseIcon />
            </IconButton>
          </Box>
        ))}
      </Box>

      {/* Add More Button */}
      <Button component="label" sx={{  borderRadius: "12px",border: "1px dashed #C5C6C7",background: "#FFF",padding: "48px 92px",height: 200,width:"47%",flexDirection:"column"}}>
        <Typography sx={{borderRadius:"8px",border:"1px solid #C8172F",padding:"14px 16px",color:"#C8172F",fontSize:"14px",fontWeight:"500",marginBottom:"10px",textTransform:"capitalize",display:"flex",gap:"8px"}}><img src={plus}  alt="" /> Add more</Typography>
        <Typography variant="h6" sx={{fontSize:"16px",fontWeight:"600",color:"#696A6B",textTransform:"capitalize"}}>Can add upto 5 Images</Typography>
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={handleAddMoreUpload}
        />
      </Button>
    </Box>
  );
};

export default ImageUploadComponent;
